import { render } from "./Register.vue?vue&type=template&id=30ddbd44&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=30ddbd44&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ddbd44"]])

export default __exports__